/* Constants for passing to canvas drawing segment
   to describe math key type entered by user
   function canvasDraw(mathKeyID, groupCode, typeCode);
   groupCode and typeCode to be constants from list below

*/

export const CV_COLOR_1 = "#FFFEFE";
export const CV_COLOR_2 = "#F9F5EC";
export const CV_COLOR_3 = "#F0F0FF"; //E1F8F9"; //"#AFEEEE";  //pale blue
export const CV_COLOR_4 = '#F1ECE5'; //"#E7E5E4";
// export const CV_COLOR_2 = "#EDD1B0"; // peach
// export const CV_COLOR_3 = "#FFE3E2";  //pink  use something like this
// export const CV_COLOR_4 = "#EDDD6E"; // orange
export const CV_COLOR_5 = '#FFE9B4';  // somewhat orange //"#F19D3B"; // bright orange
export const CV_COLOR_6 = "#F5F2D0";  // tan
export const CV_COLOR_7 = "#D8D3D6";    // grey
export const CV_COLOR_8 = "#A4D5A6";  //bluish
export const CV_COLOR_9 = "#DED8E4";   // other grey
export const CV_COLOR_10 = "#9E9E7C";  //muddy green


export const CV_MATH_COLOR_1 = "#000000";  // black
export const CV_MATH_COLOR_2 = "#2E3192";  // navy blue
export const CV_MATH_COLOR_3 = "#FF0000";  // red
export const CV_MATH_COLOR_4 = "#008000";  // green
export const CV_MATH_COLOR_5 = "#800080";  // purple
export const CV_MATH_COLOR_6 = "#0000FF";  // bright blue
export const CV_MATH_COLOR_7 = "#F7941E";  // orange
export const CV_MATH_COLOR_8 = "#FFF200";  // yellow




//cursor colors - Main math cursor, selected in user prefs
export const CV_CURSOR_COLOR: string[] = [
   "#addfad",            // Green - default value
   "teal",               // Teal
   "black",
   "rgb(0,102,51)",      // Dark Green
   "rgb(26,49,146)"      // Blue
];

// Constants used only by canvas for branch symbols/fractions cursor colors, indexed as above
export const CV_BRANCH_CURSOR_COLOR: string[][] = [
   ["blue",              // blue - default value
      "rgb(26,49,146)",     // Dark Green temporary value for testing
      "rgb(26,49,146)",     // dark bright blue
      "rgb(51,51,153)",     // Dark blue
      "purple"              // another choice is blue rgb(0,102,153)
   ],
   ["orange",
      "purple",
      "red",
      "purple",
      "orange"
   ]
];

//Grid Line darkness indexes
export const CV_GRID_LINE_INDEX_1 = 1;
export const CV_GRID_LINE_INDEX_2 = 2;
export const CV_GRID_LINE_INDEX_3 = 3;
export const CV_GRID_LINE_COLOR: string[] = [
   "gray",
   "grey",
   "black"
]

export const CV_GRID_LINE_STROKE: number[] = [
   0.3,
   0.8,
   1.2
]

export class UserPrefType {
   userId: string; fontSize: number; fontSpacing: number; isDoubleClick: boolean; isUseContrastColors: boolean; isDyslexic: boolean; hideDisplayGrid: boolean;
   A_AA_status: string; backgroundColor: string; alignEqualSign: boolean; colorEquals: boolean; cursorColorIndex: number;
   cvMainColor: string; cvOperatorsColor: string; cvEqualsColor: string; cvTextColor: string;
   useBoldMathDisplay: boolean; gridLineIndex: number;
   constructor(userId:string) {
      // initial default values first-time sign-up
      this.userId = userId;                  // store the userID from the session to distinguish login from prefs call for redraws
      this.fontSize = FONT_SIZE_LG + 1;    // canvas uses ranges starting with 0 and menu uses range starting with 1
      this.fontSpacing = 1;
      this.isDoubleClick = false;            // canvas doesn't use
      this.isUseContrastColors = false;      // canvas doesn't use
      this.isDyslexic = false;
      this.hideDisplayGrid = false;
      this.A_AA_status = CV_CNTL_AA;       // no longer used,leave for compatibility
      this.backgroundColor = CV_COLOR_1;
      this.alignEqualSign = false;
      this.colorEquals = false;           // no longer used
      this.cursorColorIndex = 1;
      this.cvMainColor = "black";
      this.cvOperatorsColor = "black";
      this.cvEqualsColor = "black";
      this.cvTextColor = "black";
      this.useBoldMathDisplay = false;
      this.gridLineIndex = 1;

   }
}



// Constant codes to identify math key "groups" as defined by canvas segment
// Each group includes the key types listed
export const CV_SIMPLE_GRP = 1;             // NUM, OPERATOR, EQUALS_INQ, SPECIAL, MISC types
export const CV_BRACKET_GRP = 2;            // BRACKET type
export const CV_LONG_GRP = 3;               // UNITS, VAR, VAR_SQR, LOG_LN types
export const CV_BRANCHING_GRP = 4;          // FRACTION, EXP_SUB, DIV_SQRT, SUM_LIMIT types
export const CV_SPEC2_GRP = 5;               // Includes ABC, LINE, and CROSS-OFF special operations


// Constant codes to identify math key "types" as defined by canvas segment

export const CV_NUM_TYPE = 10;               // Number digits 0-9
export const CV_OPERATOR_TYPE = 11;          // plus, minus, multiply, divide signs
export const CV_EQUALS_INQ_TYPE = 12;        // equals, not equals, inequalities
export const CV_SPECIAL_TYPE = 13;           // decimal point, negative sign, space symbol
export const CV_MISC_TYPE = 14;              // constants (pi, infinity, e, i) and misc key symbols
export const CV_BRACKET_TYPE = 15;           // brackets symbols
export const CV_UNITS_TYPE = 16;             // units key symbols
export const CV_VAR_TYPE = 17;               // variable key symbols
export const CV_VAR_SQR_TYPE = 18;           // variable squared key symbols
export const CV_LOG_LN_TYPE = 19;            // log and ln symbols (note "Log" in long group and "Log A" in branching group)
export const CV_TRIG_TYPE = 20;              // trig keys symbols
export const CV_FRACTION_TYPE = 21;          // fraction symbol
export const CV_EXP_SUB_TYPE = 22;           // exponent and subscript symbols
export const CV_DIV_SQRT_TYPE = 23;          // division, square root and root symbols
export const CV_SUM_LIMIT_TYPE = 24;         // summation and limit symbols
export const CV_LINE_TYPE = 25;              // Line segment key type
export const CV_CROSSOFF_TYPE = 26;          // cross-off key type
export const CV_ABC_TYPE = 27;               // keys from keyboard that are not matches to a math key symbol
export const CV_TEXT_FILL = 28;              // dummy type for null strings under text elements in grid
export const CV_TEXT_TO_LINE = 29;           // ABC entered text passed off to within a level 3/4 line to problem
export const CV_DERIVATIVE_TYPE = 30;        // calculus derivative symbols
export const CV_GEO_SYMBOL = 31;             // geometry symbols
export const CV_GEO_SHAPE = 32;              // geometry shapes
export const CV_GEO_PROOF = 33;              // geometry proof symbols
export const CV_GEO_OVER_TEXT = 34;          // geometry over-text symbols (line segment, ray, etc.)

/* Codes to be used to pass to canvas drawing segment,
*  to identify control bar key user pressed
*/
export const CV_CNTL_SET_VIEW_ONLY = "viewOnly";
export const CV_CNTL_END_VIEW_ONLY = "endViewOnly";
export const CV_CNTL_START_DRAW_TOOL = "drawToolOn";
export const CV_CNTL_END_DRAW_TOOL = "drawToolOff";
export const CV_CNTL_NEW_GRID_PROBLEM = "NewGrid";
export const CV_CNTL_UNDO = 'Undo';
export const CV_CNTL_REDO = 'Redo';
export const CV_CNTL_DELETE = 'Delete';
export const CV_CNTL_BACKSPACE = 'Backspace';
export const CV_CNTL_ENTER = 'Enter';             // from yellow exit box
export const CV_CNTL_ADVANCE = 'Advance';           // yellow to orange arrow box
export const CV_CNTL_COMPLETE = 'Complete';          // yellow to green arrow box
export const CV_CNTL_NEW_PROBLEM = 'NewP';       // yellow to lower arrow box
export const CV_CNTL_A = 'AMode';
export const CV_CNTL_AA = 'AAMode';
export const CV_CNTL_ZOOM_IN = 'ZoomIn';
export const CV_CNTL_ZOOM_OUT = 'ZoomOut';
export const CV_CNTL_FONT_INCREASE = 'FontIncrease';
export const CV_CNTL_FONT_DECREASE = 'FontDecrease';
export const CV_CNTL_ARROWRIGHT = "ArrowRight";
export const CV_CNTL_ARROWLEFT = "ArrowLeft";
export const CV_CNTL_ARROWUP = "ArrowUp";
export const CV_CNTL_ARROWDOWN = "ArrowDown";
export const CV_CNTL_PREV_PROB = "PrevProb";
export const CV_CNTL_NEXT_PROB = "NextProb";
export const CV_CNTL_COPY = "Copy";
export const CV_CNTL_PASTE = "Paste";
export const CV_CNTL_DELETE_PROBLEM = "DeleteProb";
export const CV_CNTL_DUPLICATE_LINE = "DuplicateLine";
export const CV_CNTL_WHITESPACE = "whiteSpace";
export const CV_CNTL_CLIPBOARD_SELECT = "clipSelect";



// there are extra constants not used directly by math keys
// they are keyboard key values for some control keys that drawing board matches to find
export const KEYBOARD_ENTER = 'Enter';
export const KEYBOARD_DELETE = 'Delete';
export const KEYBOARD_BACKSPACE = "Backspace";
export const KEYBOARD_ARROWRIGHT = "ArrowRight";
export const KEYBOARD_ARROWLEFT = "ArrowLeft";
export const KEYBOARD_ARROWUP = "ArrowUp";
export const KEYBOARD_ARROWDOWN = "ArrowDown";
export const KEYBOARD_INSERT = "Insert";
export const KEYBOARD_TAB = "Tab";
export const KEY_ID_LIMIT_ARROW = "\uf0e0";//"→"; in wingdings
export const KEY_ID_LONG_LINE_SEGMENT = "___";

export const CV_EMPTY_SYM = "";
// Font size constants for user preferences definition
export const FONT_SIZE_SM = 0;
export const FONT_SIZE_MED = 1;
export const FONT_SIZE_LG = 2;
export const FONT_SIZE_XLG = 3;

/**
 * These are the some Example of Math Keys ID
 * Similar way we can define more
 */
export const KEY_ID_0 = '0'; // Math key (0)
export const KEY_ID_1 = '1';// Math key (1)
export const KEY_ID_2 = '2';// Math key (2)
export const KEY_ID_3 = '3'; // Math key (3)
export const KEY_ID_4 = '4';// Math key (4)
export const KEY_ID_5 = '5';// Math key (5)
export const KEY_ID_6 = '6';// Math key (6)
export const KEY_ID_7 = '7';// Math key (7)
export const KEY_ID_8 = '8';// Math key (8)
export const KEY_ID_9 = '9';// Math key (9)

export const KEY_ID_DOLLAR = '$';        // changed - spelling
export const KEY_ID_ABC = 'abc';         // changed from ABC... more recent design eliminated dots
export const KEY_ID_PLUS = '+';// Math key (+)
export const KEY_ID_MINUS = '-';
export const KEY_ID_MULTIPLY_1 = '*';// Math key for multiply alternative 1
export const KEY_ID_MULTIPLY_2 =  '·'; // '\u22C5'; Math key for multiply alternative 2
export const KEY_ID_MULTIPLY_3 = '×';   //\u00D7';   // changed this from 'X", as unicode needed for cambria math, html is &#215, might need image if displays badly
export const KEY_ID_DIVIDE_1 = '/'; // Math key for Divide alternative 1
export const KEY_ID_DIVIDE_2 = '÷'; // Math key for Divide alternative 2
export const KEY_ID_DECIMAL = '.';      //changed name from dot
export const KEY_ID_LESS_THAN = '<';
export const KEY_ID_GREATER_THAN = '>';
export const KEY_ID_EQUAL = '=';
export const KEY_ID_SQRT_SIGN = '√';      // sign used by canvas for drawing square roots

export const KEY_ID_BLANK = '';      // default on wildcard is no symbol, used to this key pressed anyway
export const KEY_ID_PAREN_LEFT = '(';         // changed name to paren_left, to distinguish from other brackets
export const KEY_ID_PAREN_RIGHT = ')';          // changed name to paren_right, to distinguish from other brackets
export const KEY_ID_REMAINDER = 'r';         // Remainder, used in division by younger kids
// math constants
export const KEY_PI_ID = 'π';
export const KEY_ID_PI = 'π';                  // changed name from pi_2
export const KEY_ID_E = 'e';         //'\u212F';             // Euler's constant e
export const KEY_ID_I = 'i';         //  '\u2148';             // imaginary number i
export const KEY_ID_INFINITY = '\u221E'       // html &infi
//  miscellanous key symbols
export const KEY_ID_COLON = ':';
export const KEY_ID_FACTORIAL = '!';            // Math key for factorial
export const KEY_ID_COMMA = ','
export const KEY_ID_ABSOLUTE = '|';               // absolute value bar unicode '\u007C'
export const KEY_ID_ANGLE_VALUE = '∡';                   // angle sign  \u2221
export const KEY_ID_CHECKMARK = '\u2713';          // checkmark is in wingdings font
export const KEY_ID_UNION = '∪';                   // set union symbol '∪'  unicode \u22c3
export const KEY_ID_INTERSECT = '∩';      // set intersection symbol \u22c2
export const KEY_ID_ELEMENT = '∈';                // set element symbol \u2208
// New miscellanous key symbols
export const KEY_ID_PLUS_MINUS = "±";
export const KEY_ID_MU = "µ"
export const KEY_ID_ANGLE = "∠"
export const KEY_ID_ANGLE_2 = "∡"   // TEMP shim: old Angular code still references this renamed name. Remove once math-keys.ts & math-key-spoken-names.ts use KEY_ID_ANGLE / KEY_ID_ANGLE_VALUE.
export const KEY_ID_DELTA = "Δ"
export const KEY_ID_DER_F = "f’"
export const KEY_ID_CHEM_ARROW = "→"   //(cambria math font)
export const KEY_ID_CHEM_DB_ARROW = "⇌"  //(cambria math font)
export const KEY_ID_LEFT_ARROW = "←";  // Cambria math font;

// math units alternates
export const KEY_ID_PERCENT = '%';              // percent, on unit key
export const KEY_ID_CENT = '¢';                 // US cent sign
export const KEY_ID_DEGREE = '°';               // degree (temperatur) sign
export const KEY_ID_FT = 'ft';                   // US system units
export const KEY_ID_IN = 'in';
export const KEY_ID_YD = 'yd';                   // yard
export const KEY_ID_FT_MARK = "’";                   // US system units
export const KEY_ID_IN_MARK = '”';
export const KEY_ID_LB = 'lb';                  // pound - weight
export const KEY_ID_KG = 'kg';
export const KEY_ID_CM = 'cm';
export const KEY_ID_METER = 'm';            // metric units
export const KEY_ID_EURO = '€';                 // Euro sign
export const KEY_ID_BR_POUND = '£';           // British pound - money
export const KEY_ID_YEN = '¥';                  // Japnese yen
export const KEY_ID_RUPEE = '₹';
export const KEY_ID_AM = 'am';
export const KEY_ID_PM = 'pm';
export const KEY_ID_OUNCE = 'oz';
export const KEY_ID_MM = 'mm';// '£'; // 'mm';  Temp setting to add pound symbol easily, should someday be changed
export const KEY_ID_KM = 'km'; //'€'; // 'km';  Temp setting to add Euro easily, should someday be changed
export const KEY_ID_LITER = "L";
export const KEY_ID_MONEY_Q = "Q";
export const KEY_ID_MONEY_D = "D";
export const KEY_ID_MONEY_N = "N";
export const KEY_ID_MONEY_P = "P";


// brackets alternates
export const KEY_ID_SQ_BRACKET_LEFT = '[';
export const KEY_ID_SQ_BRACKET_RIGHT = ']';
export const KEY_ID_CURLY_LEFT = '{';
export const KEY_ID_CURLY_RIGHT = '}';

// Inequality alternates
export const KEY_ID_LESS_THAN_EQ = '≤';
export const KEY_ID_GREATER_THAN_EQ = '≥';
export const KEY_ID_NOT_EQUAL = '≠';
export const KEY_ID_APPROX_EQUAL = '≈';

// variables
export const KEY_ID_X = 'x';
export const KEY_ID_Y = 'y';
export const KEY_ID_Z = 'z';
export const KEY_ID_W = 'w';
export const KEY_ID_A = 'a';
export const KEY_ID_B = 'b';
export const KEY_ID_C = 'c';
export const KEY_ID_N = 'n';
export const KEY_ID_H = 'h';
export const KEY_ID_R = 'r';
export const KEY_ID_S = 's';
export const KEY_ID_T = 't';
export const KEY_ID_FX = 'f(x)';
export const KEY_ID_P = 'p';
export const KEY_ID_LAMBDA = 'λ';
export const KEY_ID_THETA = 'θ';        // theta variable for angles
export const KEY_ID_Q = 'q';

export const KEY_ID_X_SQR = 'x²';            // superscript - '\u207B';  super 2 '\u00B2'
export const KEY_ID_Y_SQR = 'y²';
export const KEY_ID_Z_SQR = 'z²';
export const KEY_ID_A_SQR = 'a²';            // superscript - '\u207B';  super 2 '\u00B2'
export const KEY_ID_B_SQR = 'b²';
export const KEY_ID_C_SQR = 'c²';
export const KEY_ID_R_SQR = 'r²';
export const KEY_ID_T_SQR = 't²';
export const KEY_ID_N_SQR = 'n²';

// Geometry keyboard symbols
export const KEY_ID_TRIANGLE = '△';           // U+25B3
export const KEY_ID_GEO_CIRCLE = '⊙';         // U+2299
export const KEY_ID_CONGRUENT = '≅';           // U+2245
export const KEY_ID_SIMILAR = '∼';             // U+223C
export const KEY_ID_PARALLEL = '∥';            // U+2225
export const KEY_ID_PERPENDICULAR = '⊥';       // U+22A5
export const KEY_ID_PRIME = '′';               // U+2032
export const KEY_ID_DOUBLE_PRIME = '″';        // U+2033
export const KEY_ID_MEASURE_ANGLE = 'm∠';      // m + U+2220
export const KEY_ID_THEREFORE = '∴';           // U+2234
export const KEY_ID_BECAUSE = '∵';             // U+2235
export const KEY_ID_RIGHT_ANGLE =  '∟';        // U+221F
export const KEY_ID_NOT_SIMILAR = '≁';         // U+2241
export const KEY_ID_CAP_A = 'A';
export const KEY_ID_CAP_B = 'B';
export const KEY_ID_CAP_C = 'C';
export const KEY_ID_CAP_D = 'D';
export const KEY_ID_CAP_E = 'E';
export const KEY_ID_CAP_F = 'F';
export const KEY_ID_CAP_P = 'P';
export const KEY_ID_CAP_Q = 'Q';
export const KEY_ID_CAP_R = 'R';
export const KEY_ID_CAP_M = 'M';
export const KEY_ID_CAP_N = 'N';
export const KEY_ID_CAP_O = 'O';
export const KEY_ID_CAP_X = 'X';
export const KEY_ID_CAP_Y = 'Y';
export const KEY_ID_CAP_Z = 'Z';
export const KEY_ID_CAP_G = 'G';
export const KEY_ID_CAP_H = 'H';
export const KEY_ID_CAP_I = 'I';
export const KEY_ID_D = 'd';
export const KEY_ID_M = 'm';
export const KEY_ID_L = 'l';
export const KEY_ID_K = 'k';
export const KEY_ID_GEO_LINE_SEG = 'gLineSeg'; // image used
export const KEY_ID_GEO_RAY = 'gRay';          // image used
export const KEY_ID_GEO_LINE = 'gLine';         // image used
export const KEY_ID_GEO_ARC = 'gArc';           // image used
export const KEY_ID_CM_SQR = 'cm²';
export const KEY_ID_M_SQR = 'm²';
export const KEY_ID_IN_SQR = 'in²';
export const KEY_ID_IN_CUBE = 'in³';
export const KEY_ID_FT_SQR = 'ft²';
export const KEY_ID_CM_CUBE = 'cm³';
export const KEY_ID_M_CUBE = 'm³';
export const KEY_ID_U = 'u';
export const KEY_ID_U_CUBE = 'u³';
export const KEY_ID_U_SQUARED = 'u²';
export const KEY_ID_FT_CUBE = 'ft³';
export const KEY_ID_MI = 'mi';


// trig symbols
export const KEY_ID_SIN = 'sin';
export const KEY_ID_COS = 'cos';
export const KEY_ID_TAN = 'tan';
export const KEY_ID_SIN_SQR = 'sin²';
export const KEY_ID_COS_SQR = 'cos²';
export const KEY_ID_TAN_SQR = 'tan²';
export const KEY_ID_INVERSE_SIN = 'sin⁻¹';
export const KEY_ID_INVERSE_COS = 'cos⁻¹';
export const KEY_ID_INVERSE_TAN = 'tan⁻¹';
export const KEY_ID_SEC = 'sec';
export const KEY_ID_CSC = 'csc';
export const KEY_ID_COT = 'cot';
export const KEY_ID_SEC_SQR = 'sec²';
export const KEY_ID_CSC_SQR = 'csc²';
export const KEY_ID_COT_SQR = 'cot²';
export const KEY_ID_INVERSE_SEC = 'sec⁻¹';
export const KEY_ID_INVERSE_CSC = 'csc⁻¹';
export const KEY_ID_INVERSE_COT = 'cot⁻¹';

export const KEY_ID_LOG = 'log';
export const KEY_ID_LOG_A = 'logA';
export const KEY_ID_LN = 'ln';               // natural log

export const KEY_ID_SUMMATION = 'Σ';
export const KEY_ID_SUMMATION_1 = 'Σ_1';
export const KEY_ID_SUMMATION_2 = 'Σ_2';    // '\u2211' summation sign in cambria math, html &sum  or &#8721

// calculus derivative key symbols
export const KEY_ID_DX = 'dx';
export const KEY_ID_DY = 'dy';
export const KEY_ID_DT = 'dt';
export const KEY_ID_DER_F2 = "f''";
export const KEY_ID_DER_1 = "d/dx";
export const KEY_ID_DER_2 = "dV/dx";
export const KEY_ID_DER_3 = "d/dt";
export const KEY_ID_DER_4 = "d²/dx²";
export const KEY_ID_DER_5 = "dy/dx";

export const KEY_ID_DER_6 = "d²y/dx²";
export const KEY_ID_DER_7 = "d²y/dt²";
export const KEY_ID_VERTICAL_LINE = "vertLine";

// calculus key symbols used only by canvas, when splitting derivative symbols
export const KEY_ID_DER_D = "der_d";
export const KEY_ID_DER_D_SQR = "d²";


// below are constants for symbols that need images to display.  Constant values are arbitrary and count be changed
export const KEY_ID_SPACE = ' ';               // space
export const KEY_ID_TAB = 'tab';
export const KEY_ID_TAB_EQUAL = 'tabEqual';
export const KEY_ID_LINE = 'line';
export const KEY_ID_LINE_1 = 'line1';             // line segment
export const KEY_ID_NEGATIVE_SIGN = 'ˉ';     // negative sign
export const KEY_ID_GRAY_CROSSOFF_1 = 'gco1';  // cross-off for gray keys
export const KEY_ID_GRAY_CROSSOFF_2 = 'gco2';  // alternate key with yellow box
export const KEY_ID_BLUE_CROSSOFF_1 = 'bco1';  // cross-off for blue keys
export const KEY_ID_BLUE_CROSSOFF_2 = 'bco2';  // alternate key with yellow box
export const KEY_ID_CROSSOFF_1 = 'co1';
export const KEY_ID_CROSSOFF_2 = 'co2';
export const KEY_ID_CROSSOFF_3 = 'co3';
export const KEY_ID_AVOGADRO = "6.023x10²³";   //'AVOGADRO';
export const KEY_ID_AVOGADRO_ALT = "6.023x10²³mol⁻¹";   //'AVOGADRO';

export const KEY_ID_FRACTION = 'frac';          // fraction sign
export const KEY_ID_FRACTION_GRID = 'frac1';          // fraction sign
export const KEY_ID_FRACTION_GRID_SIGN = '―';   // used for drawing grid fractions
export const KEY_ID_DIVISION = 'div';
export const KEY_ID_SQRT = 'sqrt';              // square root key
export const KEY_ID_ROOT = 'root';              // root key (sqrt with 'a')
export const KEY_ID_EXPONENT = 'exp';
export const KEY_ID_EXPONENT_1 = 'exp1';          // exponent key
export const KEY_ID_EXPONENT_2 = 'exp2';          // exponent key2
export const KEY_ID_E_EXPONENT = 'eexp';        // natural log exponent k
export const KEY_ID_EXPONENT_GRID = 'exp3';
export const KEY_ID_EMPTY = 'empty';

//Calculus keys

export const KEY_ID_INTEGRAL = "∫";
export const KEY_ID_INTEGRAL_1 = "integral";    // integral with yellow/orange boxes added

// export const KEY_ID_AVOGADRO = "n"
